import React, { useState } from 'react';
import './App.css';
import './styling.css'
import SideBar from './components/sideBar';
import RoomAnimation from './components/roomAnimationModel';
import Portfolio2D from './components/portfolio/Portfolio2D';
import PortfolioChooser from './components/portfolio/PortfolioChooser';

type PortfolioView = 'choose' | '3d' | '2d';

const VIEW_STORAGE_KEY = 'portfolio.view';

function App() {
  const [view, setView] = useState<PortfolioView>(() => {
    const stored = window.localStorage.getItem(VIEW_STORAGE_KEY);
    if (stored === '3d' || stored === '2d') return stored;
    return 'choose';
  });

  const handleChoose = (chosen: '3d' | '2d') => {
    window.localStorage.setItem(VIEW_STORAGE_KEY, chosen);
    setView(chosen);
  };

  const handleShowChooser = () => {
    window.localStorage.removeItem(VIEW_STORAGE_KEY);
    setView('choose');
  };

  return (
    <div className="App">
      {view === 'choose' && <PortfolioChooser onChoose={handleChoose} />}
      {view === '3d' && (
        <>
          <SideBar></SideBar>
          <RoomAnimation onSwitchView={handleShowChooser}></RoomAnimation>
        </>
      )}
      {view === '2d' && <Portfolio2D onSwitchTo3D={handleShowChooser} />}
    </div>
  );
}

export default App;
